import * as React from 'react';
import './Style.css';
//Page Sections
import ImageGallery from "./ImageGallery";
import HoneymoonNav from "./HoneymoonNav";
import Wedding from "./Wedding";

import Typography from '@mui/material/Typography';
import { Box, Tab, Tabs } from '@mui/material';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function NavBar() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <div>
      <Box>
      <Tabs value={value} onChange={handleChange} variant="scrollable" scrollButtons allowScrollButtonsMobile aria-label="basic tabs example">
        <Tab label="Honeymoon" {...a11yProps(0)} />
        <Tab label="Other Photos" {...a11yProps(1)} />
      </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <HoneymoonNav />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <ImageGallery />
      </TabPanel>
    </div>
  );
}